export const isoToFormDate = (iso: string | null | undefined): string => {
  if (!iso) return ''
  const [year, month, day] = iso.split('-')
  if (!year || !month || !day) return ''
  return `${month}/${day}/${year}`
}

export const normalizeTransmissionForForm = (value: string | null | undefined) => {
  if (!value) return ''
  switch (value.toUpperCase()) {
    case 'AUTOMATIC':
      return 'automatic'
    case 'MANUAL':
      return 'manual'
    default:
      return value.toLowerCase()
  }
}

export const normalizeTrainingModeForForm = (value: string | null | undefined) => {
  if (!value) return undefined

  switch (value.toUpperCase()) {
    case 'IN_PERSON':
    case 'IN-PERSON':
      return 'in-person'
    case 'REMOTE':
      return 'remote'
    default:
      return value.toLowerCase()
  }
}

export const normalizeFormDateValue = (value: string | null | undefined) => {
  if (!value) return ''

  const trimmedValue = value.trim()
  const dateOnlyValue = trimmedValue.split('T')[0] ?? ''

  return /^\d{4}-\d{2}-\d{2}$/.test(dateOnlyValue) ? dateOnlyValue : ''
}
